import { defineComponent, openBlock, createElementBlock, createVNode, unref, withCtx, createTextVNode, createBlock, toDisplayString, createCommentVNode } from "vue";
import { CdrText, CdrLink } from "@rei/cedar";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NewMemberOfferDetailsModal",
  props: {
    earnDates: {
      default: ""
    }
  },
  emits: ["metricsClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [createVNode(unref(CdrText), {
        tag: "h3",
        class: "new-member-offer-details-modal__heading",
        "data-ui": "new-member-offer-details-modal-heading"
      }, {
        default: withCtx(() => _cache[2] || (_cache[2] = [createTextVNode(" Annual 10% Co-op Member Reward Terms & Conditions ")])),
        _: 1,
        __: [2]
      }), createVNode(unref(CdrText), {
        tag: "p"
      }, {
        default: withCtx(() => _cache[3] || (_cache[3] = [createTextVNode(" 10% Co-op Member Reward is typical but not guaranteed. Your Co-op Member Reward is issued once every year in March. It is based on eligible net qualified purchases, which exclude REI Outlet items, sale and clearance items, discounted items, used gear, REI classes or day trips, REI adventure travel, shipping charges, return labels, exchanges, memberships, passes/tickets, service fees (e.g., rentals, labor, shop services), gift cards, event registration fees, government agencies and sales tax. ")])),
        _: 1,
        __: [3]
      }), createVNode(unref(CdrLink), {
        href: "/membership",
        class: "new-member-offer-details-modal__cta",
        target: "_blank",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("metricsClick", {
          linkName: "too far membership banner_Learn more about REI Co-op Membership"
        }))
      }, {
        default: withCtx(() => _cache[4] || (_cache[4] = [createTextVNode(" Learn more about REI Co-op Membership ")])),
        _: 1,
        __: [4]
      }), createVNode(unref(CdrText), {
        tag: "h3",
        class: "new-member-offer-details-modal__heading"
      }, {
        default: withCtx(() => _cache[5] || (_cache[5] = [createTextVNode(" New Member Bonus Card Offer Details ")])),
        _: 1,
        __: [5]
      }), _ctx.earnDates ? (openBlock(), createBlock(unref(CdrText), {
        key: 0,
        tag: "p",
        "data-ui": "new-member-offer-details-modal-earn-dates",
        class: "new-member-offer-details-modal__earn-dates"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.earnDates), 1)]),
        _: 1
      })) : createCommentVNode("", true), createVNode(unref(CdrText), {
        tag: "p"
      }, {
        default: withCtx(() => _cache[6] || (_cache[6] = [createTextVNode(" Make a $50 purchase and add a membership to your cart for a one-time $30 fee. Your $30 digital bonus card is a single-use promotional card. It will be added automatically to your cart and emailed to the address you provide. ")])),
        _: 1,
        __: [6]
      }), createVNode(unref(CdrText), {
        tag: "h4",
        class: "new-member-offer-details-modal__subheading"
      }, {
        default: withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" Digital bonus card is valid for 30 days. See email for expiration date. ")])),
        _: 1,
        __: [7]
      }), createVNode(unref(CdrLink), {
        href: "/member-thanks",
        class: "new-member-offer-details-modal__cta",
        target: "_blank",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("metricsClick", {
          linkName: "too far membership banner_Full Bonus Card Terms & Conditions"
        }))
      }, {
        default: withCtx(() => _cache[8] || (_cache[8] = [createTextVNode(" Full Bonus Card Terms & Conditions ")])),
        _: 1,
        __: [8]
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=NewMemberOfferDetailsModal2.mjs.map
